import { loader } from 'graphql.macro'

export default function feeType ({ dataLoaders, queryKey }) {
  const [, haulerId, id] = queryKey
  const schema = loader('./feeType.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(schema, { haulerId, id })
}
